import { Card } from "primereact/card";
import { Avatar } from "primereact/avatar";
import { Tag } from "primereact/tag";
import "./UserCardTemplate.css";
import DefaultProfileImage from "../../medias/images/default.jpg";
import { IdvStatus } from "../idvStatus/IdvStatus";

const UserCardTemplate = ({ user }) => {
  return (
    <Card className="user-card">
      <div className="user-card-content">
        <div className="user-avatar-container">
            {/* Avatar */}
            <Avatar 
            image={user.image || DefaultProfileImage} 
            shape="circle" 
            size="large" 
            className="user-avatar"
            />
            {/* ID */}
            <Tag value={`ID: ${user.id}`} severity="info" style={{whiteSpace:"nowrap"}}/>

        </div>

        {/* Infos */}
        <div className="user-info">
          <div className="user-header">
            <span className="user-name">
              {user.fullName}
            </span>

          </div>

          <div className="user-job">
            {user.jobDescription || "No role defined"}
          </div>

          <div className="user-location">
            {user.city || "—"}
          </div>

          <div className="user-location">
            <IdvStatus status={user.trolleyIdvStatus} />
          </div>
        </div>

      </div>
    </Card>
  );
};

export default UserCardTemplate;